import { MenuItem, withStyles } from '@material-ui/core';

/**
 * @internal
 */
const StyledMenuItem = withStyles(theme => ({
  root: {
    '&:focus': {
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.gray800,
      },
      backgroundColor: theme.palette.common.blue50,
    },
    fontFamily: theme.typography.body2.fontFamily,
    fontSize: theme.typography.body2.fontSize,
    fontWeight: 400,
    lineHeight: '16px',
    paddingLeft: theme.spacing(3.125),
    paddingRight: theme.spacing(1.25),
  },
  selected: {
    '&:hover': {
      backgroundColor: `${theme.palette.common.blue50} !important`,
    },
    backgroundColor: `${theme.palette.common.blue50} !important`,
  },
}))(MenuItem);

/**
 * @internal
 */
export default StyledMenuItem;
